/* A-127: PostHog (EU) — аналітика, error tracking, записи сесій.
   Конфіг: <script id="LystiaPostHogConfig"> із snippets/posthog.liquid.
   До згоди на cookies (Shopify Customer Privacy API) — persistence: memory; після згоди — localStorage+cookie.
   Помилки кошика: подія cart:error з lystia-cart.js -> posthog.captureException.
   Перф (мобільний): завантаження відкладене до першої взаємодії або ~4 с після load,
   щоб array.js і recorder не займали main-thread у вікні LCP/TBT. */
(function () {
  var cfgEl = document.getElementById('LystiaPostHogConfig');
  if (!cfgEl) return;
  var cfg;
  try { cfg = JSON.parse(cfgEl.textContent) || {}; } catch (e) { return; }
  if (!cfg.key) return;

  /* Cookie ph_<key>_posthog пишеться лише після згоди: якщо він є, стартуємо з ним, інакше memory генерує новий id на кожній сторінці */
  var stored = document.cookie.indexOf('ph_' + cfg.key + '_posthog=') !== -1;

  var started = false;
  function start() {
    if (started) return;
    started = true;
    EVENTS.forEach(function (n) { window.removeEventListener(n, start, LISTEN); });
    /* Офіційний завантажувач posthog-js (array.js з CDN PostHog, виняток з §4 за A-127) */
    // prettier-ignore
    !function(t,e){var o,n,p,r;e.__SV||(window.posthog&&window.posthog.__loaded)||(window.posthog=e,e._i=[],e.init=function(i,s,a){function g(t,e){var o=e.split(".");2==o.length&&(t=t[o[0]],e=o[1]),t[e]=function(){t.push([e].concat(Array.prototype.slice.call(arguments,0)))}}(p=t.createElement("script")).type="text/javascript",p.crossOrigin="anonymous",p.async=!0,p.src=s.api_host.replace(".i.posthog.com","-assets.i.posthog.com")+"/static/array.js",(r=t.getElementsByTagName("script")[0]).parentNode.insertBefore(p,r);var u=e;for(void 0!==a?u=e[a]=[]:a="posthog",u.people=u.people||[],u.toString=function(t){var e="posthog";return"posthog"!==a&&(e+="."+a),t||(e+=" (stub)"),e},u.people.toString=function(){return u.toString(1)+".people (stub)"},o="init capture register register_once register_for_session unregister unregister_for_session getFeatureFlag getFeatureFlagPayload isFeatureEnabled reloadFeatureFlags on onFeatureFlags onSessionId identify setPersonProperties group resetGroups reset get_distinct_id getGroups get_session_id get_session_replay_url alias set_config startSessionRecording stopSessionRecording sessionRecordingStarted captureException loadToolbar get_property getSessionProperty createPersonProfile opt_in_capturing opt_out_capturing has_opted_in_capturing has_opted_out_capturing clear_opt_in_out_capturing debug getPageViewId".split(" "),n=0;n<o.length;n++)g(u,o[n]);e._i.push([i,s,a])},e.__SV=1)}(document,window.posthog||[]);

    var ph = window.posthog;
    ph.init(cfg.key, {
      api_host: 'https://eu.i.posthog.com',
      defaults: '2025-05-24',
      person_profiles: 'identified_only',
      persistence: stored ? 'localStorage+cookie' : 'memory',
      capture_exceptions: true,
      disable_session_recording: !!cfg.noReplay,
      session_recording: { maskAllInputs: true },
    });
    ph.register({ theme_id: cfg.themeId, page_type: cfg.pageType });

    /* Згода на cookies */
    function applyConsent() {
      var cp = window.Shopify && window.Shopify.customerPrivacy;
      if (cp && typeof cp.analyticsProcessingAllowed === 'function' && cp.analyticsProcessingAllowed()) {
        ph.set_config({ persistence: 'localStorage+cookie' });
      }
    }
    document.addEventListener('visitorConsentCollected', applyConsent);
    if (window.Shopify && typeof window.Shopify.loadFeatures === 'function') {
      window.Shopify.loadFeatures([{ name: 'consent-tracking-api', version: '0.1' }], function (err) {
        if (!err) applyConsent();
      });
    }
  }

  var EVENTS = ['pointerdown', 'keydown', 'scroll', 'touchstart'];
  var LISTEN = { passive: true, once: true };
  EVENTS.forEach(function (n) { window.addEventListener(n, start, LISTEN); });
  function later() { setTimeout(start, 4000); }
  if (document.readyState === 'complete') later(); else window.addEventListener('load', later, { once: true });

  /* Помилки кошика (add / change / upsell / швидке додавання) */
  document.addEventListener('cart:error', function (event) {
    var d = event.detail || {};
    var err = new Error('cart:' + (d.reason || 'unknown') + ' ' + (d.message || ''));
    err.name = 'CartError';
    start();
    window.posthog.captureException(err, { area: 'cart', reason: d.reason, status: d.status });
  });
})();
